import type React from 'react';
import { IRapport } from '../../_Common/Const/Delsystem';
import Etikett from './BJEtiketter/BJEtikett';

const BJRapporter: { [rapportID: string]: IRapport } = {
  BJEtikett: {
    component: Etikett as React.ComponentType<React.PropsWithChildren<{}>>,
  },
};

export default BJRapporter;
